import { Box, Card } from '@mui/material'
import { useMemo } from 'react'
import { isDesktop } from 'react-device-detect'
import { GetHomeScreenQuery } from '~/__generated__/graphql'
import { SlideGroup } from '~/components/SlideGroup'
import { NewVideoItemCard, VideoItemCard } from '~/features/video/components/Card/VideoItemCard'
import { VideoRankingItemCard } from '~/features/video/components/Card/VideoRankingItemCard'
import { getSizeStyle } from '../Card/VideoItemCard/getSizeStyle'

interface CardGroupProps {
  videos: GetHomeScreenQuery['homeScreens'][0]['videos']
  onClickVideoItem: (videoId: number, isKeyVisual: boolean) => void
  onGetConversion?: () => void
}

export const DefaultCardGroup = ({ videos, onClickVideoItem, onGetConversion }: CardGroupProps) => {
  const sizeStyle = useMemo(() => getSizeStyle(false), [])
  return (
    <SlideGroup isLoading={videos === undefined}>
      {videos &&
        videos.map((video) =>
          isDesktop ? (
            <Box key={video.id} flexShrink={0}>
              <NewVideoItemCard video={video} onGetConversion={onGetConversion} />
            </Box>
          ) : (
            <Box key={video.id} flexShrink={0}>
              <VideoItemCard
                video={video}
                onClickCard={() => onClickVideoItem(Number(video.id), false)}
              />
            </Box>
          ),
        )}
      {/* Loading State */}
      {videos === undefined && (
        <>
          <Box flexShrink={0}>
            <Card sx={sizeStyle} />
          </Box>
          <Box flexShrink={0}>
            <Card sx={sizeStyle} />
          </Box>
          <Box flexShrink={0}>
            <Card sx={sizeStyle} />
          </Box>
          <Box flexShrink={0}>
            <Card sx={sizeStyle} />
          </Box>
          <Box flexShrink={0}>
            <Card sx={sizeStyle} />
          </Box>
          <Box flexShrink={0}>
            <Card sx={sizeStyle} />
          </Box>
          <Box flexShrink={0}>
            <Card sx={sizeStyle} />
          </Box>
          <Box flexShrink={0}>
            <Card sx={sizeStyle} />
          </Box>
          <Box flexShrink={0}>
            <Card sx={sizeStyle} />
          </Box>
          <Box flexShrink={0}>
            <Card sx={sizeStyle} />
          </Box>
        </>
      )}
    </SlideGroup>
  )
}

export const RankingCarGroup = ({ videos, onClickVideoItem }: CardGroupProps) => {
  return (
    <SlideGroup isLoading={videos === undefined}>
      {videos &&
        videos.map((video, idx) => (
          <Box key={video.id} flexShrink={0}>
            {/* ランキングは1から始まるのでインクリメントする */}
            <VideoRankingItemCard
              video={video}
              onClickCard={() => onClickVideoItem(Number(video.id), false)}
              rankNumber={idx + 1}
            />
          </Box>
        ))}
      {/* Loading State */}
      {videos === undefined && (
        <>
          <Box flexShrink={0}>
            <Card
              sx={{
                width: { xs: 108, sm: 162 },
                height: { xs: 160, sm: 240 },
              }}
            />
          </Box>
          <Box flexShrink={0}>
            <Card
              sx={{
                width: { xs: 108, sm: 162 },
                height: { xs: 160, sm: 240 },
              }}
            />
          </Box>
          <Box flexShrink={0}>
            <Card
              sx={{
                width: { xs: 108, sm: 162 },
                height: { xs: 160, sm: 240 },
              }}
            />
          </Box>
          <Box flexShrink={0}>
            <Card
              sx={{
                width: { xs: 108, sm: 162 },
                height: { xs: 160, sm: 240 },
              }}
            />
          </Box>
          <Box flexShrink={0}>
            <Card
              sx={{
                width: { xs: 108, sm: 162 },
                height: { xs: 160, sm: 240 },
              }}
            />
          </Box>
          <Box flexShrink={0}>
            <Card
              sx={{
                width: { xs: 108, sm: 162 },
                height: { xs: 160, sm: 240 },
              }}
            />
          </Box>
          <Box flexShrink={0}>
            <Card
              sx={{
                width: { xs: 108, sm: 162 },
                height: { xs: 160, sm: 240 },
              }}
            />
          </Box>
          <Box flexShrink={0}>
            <Card
              sx={{
                width: { xs: 108, sm: 162 },
                height: { xs: 160, sm: 240 },
              }}
            />
          </Box>
          <Box flexShrink={0}>
            <Card
              sx={{
                width: { xs: 108, sm: 162 },
                height: { xs: 160, sm: 240 },
              }}
            />
          </Box>
          <Box flexShrink={0}>
            <Card
              sx={{
                width: { xs: 108, sm: 162 },
                height: { xs: 160, sm: 240 },
              }}
            />
          </Box>
        </>
      )}
    </SlideGroup>
  )
}
